import React from "react";
import MuiList from "@material-ui/core/List";
import PropTypes from "prop-types";

/**
 * List component wrapper for lists.
 * Wraps Material-UI List with theme integration.
 * 
 * @component
 * @example
 * <List>
 *   <ListItem>
 *     <ListItemText primary="Item 1" />
 *   </ListItem>
 * </List>
 */
const List = ({ children, ...props }) => {
  return <MuiList {...props}>{children}</MuiList>;
};

List.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * If true, compact vertical padding designed for keyboard and mouse input is used
   */
  dense: PropTypes.bool,
  /**
   * If true, vertical padding is removed from the list
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally ListSubheader
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI List behavior

export default List;

